// extracted by mini-css-extract-plugin
export default {"container":"videoYoutube_container__RmwOF"};